import React from "react";
import { FaFilePdf } from "react-icons/fa";
import demo1 from "../../assets/documents/Letter.pdf";
import demo2 from "../../assets/documents/Citizenscharter.pdf";
import { useSelector } from "react-redux";
import { convertToMarathiNumber } from "../../components/marathiNumbers";
import { Link } from "react-router-dom";

const Citizencharter = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Citizen Charter",
      breadcrumb: {
        home: "HOME",
        page: "CITIZEN CHARTER",
      },
      paragraph1: `As per the provisions of Section 8 (1)(2) of the Maharashtra Regulation of Transfers and Prevention of Delay in Discharge of Official Duties Act, 2005, appropriate amendments have been made to the previously published Citizens’ Charter, and the revised charter is hereby being published. This department is committed to providing services related to it promptly, courteously, and respectfully to the citizens.`,
      paragraph2: `The various monuments under the Department of Cultural Affairs are also considered tourist attractions. The Directorate of Archaeology was established in September 1955, and from October 15, 1976, the name of the Directorate was changed to the Directorate of Archaeology and Museums.`,
      paragraph3: `It is the responsibility of this directorate to survey ancient and historical monuments, declare those of importance from the state’s perspective as "State Protected Monuments," and ensure their preservation and conservation.`,
      paragraph4: `Under the Directorate of Archaeology and Museums, there are three distinct departments functioning: the Archaeology Department, the Museum Department, and the Conservation Department. There are a total of 13 museums under the jurisdiction of this directorate.`,
    },
    मराठी: {
      title: "नागरिकांची सनद",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "नागरिकांची सनद",
      },
      paragraph1: `महाराष्ट्र शासकीय कर्मचाऱ्यांच्या बदल्यांचे विनियमन व शासकीय कर्तव्य पार पाडताना होणाऱ्या विलंबास प्रतिबंध अधिनियम २००५ मधील कलम ८ (१)(२) मधील तरतुदीनुसार यापूर्वी प्रसिद्ध केलेल्या नागरिकांच्या सनदेत यथायोग्य सुधारणा करून प्रस्तुत सनद प्रसिद्ध करण्यात येत आहे. या विभागाशी संबंधित असणाऱ्या सेवा तत्परतेने, सौजन्यपूर्वक व सन्मानपूर्वक नागरिकांना उपलब्ध करण्यासाठी हा विभाग बांधिल राहील.`,
      paragraph2: `सांस्कृतिक कार्य विभांगातर्गत असलेली विविध स्मारके ही प्रेक्षणीय स्थळामध्येही गणली जातात. पुरातत्त्व संचालनालयाची स्थापना सप्टेंबर १९५५ मध्ये झाली असून दिनांक १५ ऑक्टोबर १९७६ पासून या संचालनालयाचे नाव बदलून पुरातत्त्व व वस्तुसंग्रहालये संचालनालय असे करण्यात आले.`,
      paragraph3: `प्राचीन आणि ऐतिहासिक स्मारकांचे गवेक्षण करून त्यातील राज्याच्या दृष्टिकोनातून महत्वाची असलेली स्मारके “राष्ट्रीय संरक्षित स्मारक” म्हणुन घोषित करून त्यांचे जतन व संवर्धन करणे ही या संचालनालयाची जबाबदारी आहे. पुरातत्त्व व वस्तुसंग्रहालये संचालनालया अंतर्गत पुरातत्त्व विभाग, वस्तुसंग्रहालय विभाग व जतन विभाग असे ३ स्वतंत्र विभाग कार्यरत आहेत. या संचालनालयाच्या अधिनस्त १३ वस्तुसंग्रहालये आहेत.`,
      paragraph: ``,
    },
  };

  const t = content[selectedLang];

  const tableHeaders = {
    srNo: {
      English: "Sr. No.",
      मराठी: "अ.क्र.",
    },
    name: {
      English: "Name",
      मराठी: "नाव",
    },
    download: {
      English: `Download`,
      मराठी: `डाउनलोड`,
    },
  };

  const documents = [
    {
      id: 1,
      name: {
        English: "Citizen Charter Letter",
        मराठी: "नागरिकांची सनद पत्र",
      },
      file: demo1,
    },
    {
      id: 2,
      name: {
        English: "Citizen Charter",
        मराठी: "नागरिकांची सनद",
      },
      file: demo2,
    },
  ];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      {/* Page Title and Breadcrumb */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black space-y-4 mt-8 font-futura">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph1}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph2}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph3}
        </p>
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph4}
        </p>
      </div>

      {/* Table Section */}
      <div className="max-w-5xl mx-auto mt-12 overflow-x-auto no-dark-bg">
        <div
          className="bg-[#EFEDE0] rounded-xl overflow-hidden"
          style={{ border: "2px solid #F8D6BF" }}
        >
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead
              className="font-bold tracking-wide"
              style={{
                textShadow: "0.3px 0.3px 0 black",
              }}
            >
              <tr>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.srNo[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.name[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.download[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {documents.map((doc, index) => (
                <tr key={doc.id} className="hover:bg-[#F6F6EC]">
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {selectedLang === "मराठी"
                      ? convertToMarathiNumber(index + 1)
                      : `${index + 1}`}
                    .
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {doc.name[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    <div className="flex justify-center items-center h-full">
                      <a
                        href={doc.file}
                        download
                        title="Download PDF"
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaFilePdf size={20} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Citizencharter;
